__turbopack_context__.v({
  "check": "NavLanguageMenu-module-scss-module__dPQM5W__check",
  "code": "NavLanguageMenu-module-scss-module__dPQM5W__code",
  "container": "NavLanguageMenu-module-scss-module__dPQM5W__container",
  "globe": "NavLanguageMenu-module-scss-module__dPQM5W__globe",
  "isOpen": "NavLanguageMenu-module-scss-module__dPQM5W__isOpen",
  "isSelected": "NavLanguageMenu-module-scss-module__dPQM5W__isSelected",
  "option": "NavLanguageMenu-module-scss-module__dPQM5W__option",
  "options": "NavLanguageMenu-module-scss-module__dPQM5W__options",
  "panel": "NavLanguageMenu-module-scss-module__dPQM5W__panel",
  "trigger": "NavLanguageMenu-module-scss-module__dPQM5W__trigger",
});
